import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_DUNOGIAONHANVIEN } from "../actions/DuNoGiaoNhanVien/actionTypes";
import {
  getListDuNoGiaoNhanVienSuccess,
  getListDuNoGiaoNhanVienFailure,
} from "../actions/DuNoGiaoNhanVien";
import DuNoGiaoNhanVienApi from "../service/duNoGiaoNhanVien";

function* getListDuNoGiaoNhanVien(action) {
  try {
    const response = yield call(DuNoGiaoNhanVienApi.list1, action.dataSearch);
    if (response.ok) {
      yield put(getListDuNoGiaoNhanVienSuccess(response.data));
    } else {
      yield put(getListDuNoGiaoNhanVienFailure());
    }
  } catch (error) {
    yield put(getListDuNoGiaoNhanVienFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_DUNOGIAONHANVIEN, getListDuNoGiaoNhanVien);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
